export const translation: { [key: string]: string } = {
  "authentication credentials were not provided.":
    "As credenciais de autenticação não foram fornecidas.",
  "not found": "Não encontrado",
};
